import {getRequest, URL_SERVER} from './../requests'


export async function getOffers(token){
    try {
        return await getRequest(URL_SERVER + '/offers', token)
    } catch (error) {
        console.error(error);
    }
}